import { createAction } from 'helpers/redux-actions.helper'
import { ActionsUnion } from 'helpers/types.helper'
import {
  LikertAnswer,
  NextLessonRejection,
  OpenEndedAnswer,
} from 'store/states/lessons.state'
import { IBlockInstanceModel } from 'models/block.model'
import { QuestionTypeV1 } from 'enum/question-type'
import { ILessonModel } from '../../models/lesson.model'
import { Attachment } from '../../models/attachments.model'

export const LESSONS_GET_LESSON = 'LESSONS_GET_LESSON'
export const LESSONS_GET_LESSON_SUCCESS = 'LESSONS_GET_LESSON_SUCCESS'
export const LESSONS_LOAD_FAILURE = 'LESSONS_LOAD_FAILURE'
export const LESSONS_GET_LESSON_RICHTEXT_BLOCK =
  'LESSONS_GET_LESSON_RICHTEXT_BLOCK'
export const LESSONS_GET_LESSON_RICHTEXT_BLOCK_SUCCESS =
  'LESSONS_GET_LESSON_RICHTEXT_BLOCK_SUCCCESS'
export const LESSONS_GET_LESSON_SURVEY_BLOCK = 'LESSONS_GET_LESSON_SURVEY_BLOCK'
export const LESSONS_GET_LESSON_SURVEY_BLOCK_SUCCESS =
  'LESSONS_GET_LESSON_SURVEY_BLOCK_SUCCESS'
export const LESSONS_GET_NEXT_LESSON = 'LESSONS_GET_NEXT_LESSON'
export const LESSONS_GET_NEXT_LESSON_SUCCESS = 'LESSONS_GET_NEXT_LESSON_SUCCESS'
export const LESSONS_GET_NEXT_LESSON_FAILURE = 'LESSONS_GET_NEXT_LESSON_FAILURE'
export const LESSONS_CLEAR_NORMATIVE_ACCESS_ERROR =
  'LESSONS_CLEAR_NORMATIVE_ACCESS_ERROR'
export const LESSONS_NEXT_LESSON_REJECTED = 'LESSONS_NEXT_LESSON_REJECTED'
export const LESSONS_CLEAR_NEXT_LESSON_REJECTION =
  'LESSONS_CLEAR_NEXT_LESSON_REJECTION'
export const LESSONS_GET_LESSON_CONTENT = 'LESSONS_GET_LESSON_CONTENT'
export const LESSONS_GET_LESSON_CONTENT_SUCCESS =
  'LESSONS_GET_LESSON_CONTENT_SUCCESS'
export const LESSONS_SET_ATTACHMENTS_TASK = 'LESSONS_SET_ATTACHMENTS_TASK'
export const LESSONS_REMOVE_ATTACHMENT_TASK = 'LESSONS_REMOVE_ATTACHMENT_TASK'
export const LESSONS_SURVEY_SET_QUESTION_RESPONSE =
  'LESSONS_SURVEY_SET_QUESTION_RESPONSE'

export interface LessonsSetAttachmentsTaskParams {
  index: number
  data: Attachment[]
}

export interface LessonsRemoveAttachmentTaskParams {
  index: number
  token: string
}

export interface LessonsSetQuestionResponseParams {
  index: number
  questionIndex: number
  value:
    | {
        type: QuestionTypeV1.openEnded
        answer: OpenEndedAnswer
      }
    | {
        type: QuestionTypeV1.likert
        answer: LikertAnswer
      }
}

export const Actions = {
  lessonsGetLessonSuccess: (data: ILessonModel) =>
    createAction(LESSONS_GET_LESSON_SUCCESS, data),
  lessonsLoadFailure: () => createAction(LESSONS_LOAD_FAILURE),
  lesssonGetLessonRichTextBlock: (data: any) =>
    createAction(LESSONS_GET_LESSON_RICHTEXT_BLOCK_SUCCESS, data),
  lesssonGetLessonSurveyBlock: (data: any) =>
    createAction(LESSONS_GET_LESSON_SURVEY_BLOCK_SUCCESS, data),
  lesssonGetNextLessonSuccess: (data: any) =>
    createAction(LESSONS_GET_NEXT_LESSON_SUCCESS, data),
  lesssonGetNextLessonFailure: (reason: string) =>
    createAction(LESSONS_GET_NEXT_LESSON_FAILURE, reason),
  lessonsClearNormativeAccessError: () =>
    createAction(LESSONS_CLEAR_NORMATIVE_ACCESS_ERROR),
  lessonsNextLessonRejected: (rejection: NextLessonRejection) =>
    createAction(LESSONS_NEXT_LESSON_REJECTED, rejection),
  lessonsClearNextLessonRejection: () =>
    createAction(LESSONS_CLEAR_NEXT_LESSON_REJECTION),
  lessonsGetLessonContent: (payload: {
    blockInstances: IBlockInstanceModel[]
    lessonId: any
  }) => createAction(LESSONS_GET_LESSON_CONTENT, payload),
  lessonsGetLessonContentSuccess: (data: number) =>
    createAction(LESSONS_GET_LESSON_CONTENT_SUCCESS, data),
  lessonsSetAttachmentsTask: (data: LessonsSetAttachmentsTaskParams) =>
    createAction(LESSONS_SET_ATTACHMENTS_TASK, data),
  lessonsRemoveAttachmentTask: (data: LessonsRemoveAttachmentTaskParams) =>
    createAction(LESSONS_REMOVE_ATTACHMENT_TASK, data),
  lessonsSurveySetQuestionResponse: (data: LessonsSetQuestionResponseParams) =>
    createAction(LESSONS_SURVEY_SET_QUESTION_RESPONSE, data),
}

export type Actions = ActionsUnion<typeof Actions>
